import {IEventParams} from '@signage/interface/dist/IEventParams';
import {BehaviorSubject, Observable, ReplaySubject, skip, Subject} from 'rxjs';

export class EventParams implements IEventParams {
  subjects = {};

  constructor() {
  }

  getEventParam(eventName: string): Observable<any> {
    let subject: Observable<any> = this.subjects[eventName];
    if (subject==null) {
      subject = this.subjects[eventName] = new Subject();
    }
    return subject;
  }

  dispatch(eventName: string, param: any, store: boolean): void {
    let subject: Subject<any> = this.subjects[eventName];
    if (subject==null) {
      this.subjects[eventName] = subject = new Subject();
    }
    subject.next(param);
  }

  getParam(eventName: string): any {
    if (this.subjects[eventName] as BehaviorSubject<any>) {
      return (<BehaviorSubject<any>>this.subjects[eventName]).value;
    } else {
      return null;
    }
  }
}

